var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 11.0213C9.8395 9.65957 7.87098 9.65957 7.03759 11.0213L2.31997 18.7294C1.4449 20.1592 2.46795 22 4.13762 22H8.25V19.7819C7.51704 19.3369 7 18.259 7 17C7 15.3431 7.89543 14 9 14C10.1046 14 11 15.3431 11 17C11 18.259 10.483 19.3369 9.75 19.7819V22H19.8622C21.5556 22 22.5746 20.1121 21.6517 18.6845L18.6481 14.0384C17.8065 12.7365 15.9109 12.7365 15.0692 14.0384L13.7595 16.0644L10.6729 11.0213Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10C19.75 9.58579 19.4142 9.25 19 9.25C18.5858 9.25 18.25 9.58579 18.25 10V12C18.25 12.4142 18.5858 12.75 19 12.75C19.4142 12.75 19.75 12.4142 19.75 12V10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9947 8.00531C16.2876 8.29821 16.2876 8.77308 15.9947 9.06597L14.5805 10.4802C14.2876 10.7731 13.8127 10.7731 13.5198 10.4802C13.2269 10.1873 13.2269 9.71242 13.5198 9.41953L14.934 8.00531C15.2269 7.71242 15.7018 7.71242 15.9947 8.00531Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.75C14.4142 5.75 14.75 5.41421 14.75 5C14.75 4.58579 14.4142 4.25 14 4.25H12C11.5858 4.25 11.25 4.58579 11.25 5C11.25 5.41421 11.5858 5.75 12 5.75H14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/forest.aeeb9e68942778c8482773c2a706f76b.svg";
export { ForwardRef as ReactComponent };